import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactLoading from "./Loading";
import dom from "../utils/dom";
import UpdatesLayout from "./hoc/UpdatesLayout";
import g from "../utils/globals";
import * as common from "../editmode/editModeCommon";

class Dynamic extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    if (!this.props.carousel && this.props.bodyClassName) {
      dom.addBodyClass(this.props.bodyClassName);
    }
  };

  componentWillUnmount = () => {
    if (!this.props.carousel && this.props.bodyClassName) {
      dom.removeBodyClass(this.props.bodyClassName);
    }
  };

  addClassName = props => {
    const className = `${props.module.toLowerCase()}-component`;

    if (!props.attrs) {
      props.attrs = { className };
    } else if (!props.attrs.className) {
      props.attrs.className = className;
    } else if (props.attrs.className.indexOf(className) !== -1) {
      props.attrs.className = `${className} ${props.attrs.className || ""}`;
      if (props.attrs.className.length >= 1) {
        props.attrs.className = Array.from(new Set(props.attrs.className.split(" "))).join(" ");
      }
    }
  };

  enhance = props => {
    const newProps = Object.assign({}, props, props.customProps);
    this.addClassName(newProps);
    return newProps;
  };

  selectComponent = (e, props) => {
    document.querySelectorAll("#bottom-bar form").forEach(x => x.classList.add("hide"));
    common.removeSelected();
    const current = e.target.closest(".collage-item");
    if (current) {
      current.classList.add("item-selected");
      const collage = common.getCollage();
      const composition = props.contents.find(x => x.dataAttrs["data-content"] === collage);
      const selected = composition.contents.find(x => x.id === current.id);
      this.props.onComponentSelected({ props: selected });
    } else {
      this.props.onComponentSelected();
    }
  };

  render = () => {
    if (!this.props.module) {
      return <ReactLoading type="spin" />;
    }
    const props = this.enhance(this.state.props || this.props);
    const updatesLayout = <UpdatesLayout {...props} active={this.props.active} />;
    if (g.editMode && this.props.selectionMode) {
      return (
        <div onMouseDown={e => this.selectComponent(e, props)} id="selection-layer">
          {updatesLayout}
        </div>
      );
    }
    return updatesLayout;
  };
}

Dynamic.propTypes = {
  active: PropTypes.bool,
  module: PropTypes.string,
};

export default Dynamic;
